export default {
    upgrade: {
        title: 'あなたに合ったプランを選択',
        subtitle: 'プロフェッショナル機能をアンロックし、生産性を向上',
        pickYourPlan: 'プランを選択',
        subscribeSuccess: 'サブスクリプション成功',
        contactSales: 'エンタープライズソリューションについては、営業チームにお問い合わせください。',
        enterpriseRestriction: '有料サブスクリプションは現在、個人ユーザーのみご利用いただけます。企業ユーザーの方は、営業チームまでお問い合わせください。',
        freeplanActivated: 'ベーシックプランが有効です',
        planNotFound: '選択されたプランが見つかりません',
        alreadySubscribed: 'すでにこのプランに登録されています',
        priceIdNotConfigured: 'このプランの支払い設定が利用できません',
        paymentInitFailed: '支払いの初期化に失敗しました。再試行してください。',
        plans: {
            period: {
                monthly: ' / 月',
                yearly: ' / 年',
            },
            basic: {
                name: 'ベーシック',
                subtitle: '初心者に不可欠なコア機能',
                price: '無料',
                description: 'AI エージェントによる一貫した特許検索・明細書作成をフル体験',
                button: '今すぐ始める',
            },
            pro: {
                name: 'プロ',
                subtitle: 'プロフェッショナル向けの高度なツール',
                description: '特許出願業務フローを高速化',
                button: 'プロプランに申し込む',
                moduleName: 'プロ（月払い/年払い）',
                yearlySavings: '年払いでさらにお得',
                featuresHeader: '世界各国の特許出願に対応した明細書作成支援機能：',
                features: {
                    additionalHiroMessages: 'Hiro コパイロット追加チャット回数',
                    fullDocumentExports: 'フルドキュメントエクスポート',
                    disclosure1Doc: '発明開示書作成 ({n}件)',
                    application1Doc: '特許出願書類作成 ({n}件)',
                    oar1Doc: '拒絶理由通知応答 ({n}件)',
                },
            },
            enterprise: {
                name: 'エンタープライズ',
                subtitle: '組織全体への包括的なインテリジェンス',
                price: 'お問い合わせ',
                description: '企業向け包括的な知的財産保護ソリューション',
                button: 'デモを予約する',
                featuresHeader: '明細書作成プロプランの全機能に加えて：',
                features: {
                    securityHeader: 'セキュリティ・管理機能：',
                },
                benefits: {
                    expandedSearch: '検索量の拡大',
                    humanInLoop: 'ヒューマン・イン・ザ・ループ',
                    advancedEditor: '高度なインラインエディター',
                    workspaceIntegration: 'ワークスペース統合',
                    professionalExport: 'プロフェッショナルドキュメントエクスポート',
                    evenMoreHiro: 'さらに多くの Hiro コパイロットチャット回数',
                    ssoSecurity: 'SSO シングルサインオン & 高度セキュリティ',
                    dedicatedSuccess: '専属カスタマーサクセスマネージャー',
                },
            },
            api: {
                name: 'API',
                subtitle: '開発者優先の統合ソリューション',
                price: 'カスタム',
                description: 'シームレスな知的財産インテリジェンス統合',
                button: '詳細を見る',
                features: {
                    unifiedAiDataLoop: '実用的なインサイトのための統合 AI データループ',
                    instantIntegration: 'モジュール式ウィジェットと SDK による即時統合',
                    predictableScaling: '透明な使用モデルによる予測可能なスケーリング',
                    infrastructure: 'エンタープライズグレードのインフラストラクチャ、99.9% SLA',
                    connectivity: '主要な技術スタック全体での普遍的な接続性',
                    support: 'プロアクティブなサポートとヘルスモニタリング',
                },
            },
            features: {
                hiroMessages: 'Hiro コパイロットとのチャット機能',
                disclosure: '発明開示書作成',
                application: '特許出願書類作成',
                oar: '拒絶理由通知応答',
                templateInstructionStyle: 'テンプレート / 指示 / スタイルのカスタマイズ',
                wordWpsPlugin: 'Word プラグイン（近日公開予定）',
            },
        },
        billingCycle: {
            monthly: '月払い',
            yearly: '年払い',
            saveAmount: '$ {amount} お得',
        },
        features: 'プラン機能',
        benefits: '特典',
        recommend: 'おすすめ',
        comparison: {
            title: 'プランを比較',
            plans: {
                guest: 'ゲスト',
                free: 'ベーシック',
                pro: 'プロ',
                enterprise: 'エンタープライズ',
            },
            categories: {
                agent: 'コア Agent',
                features: 'その他の機能',
                ai: 'AI ツール',
                security: 'セキュリティ・管理',
                collaboration: 'エンタープライズコラボレーション',
            },
            rows: {
                disclosure: '発明開示書作成',
                application: '特許出願書類作成',
                oar: '拒絶理由通知応答',
                templates: 'テンプレート',
                instructions: '指示',
                styles: 'スタイル',
                draftingCenter: 'ドラフティングセンター',
                officePlugin: 'Word プラグイン（近日公開予定）',
                aiChat: 'AI チャット',
                chatLimitN: '{n} 回/日',
                chatLimit500: '500 回/日',
                moreUsage: 'より高い上限',
                evenMoreUsage: 'カスタム上限',
                createProject: 'プロジェクト作成',
                exportProject: 'プロジェクトエクスポート',
                sharedAssets: 'テンプレート/指示/スタイル共有',
                enterpriseManagement: 'エンタープライズ管理',
            },
        },
    },
    pricing: {
        payment: {
            errors: {
                createSessionFailed: '支払いセッションの作成に失敗しました。現在のアカウントタイプをご確認ください。',
                verifyFailed: '支払い状態の確認に失敗しました',
                verificationFailed: '支払いの確認に失敗しました',
                verificationError: '確認中にエラーが発生しました',
                invalidCallback: '無効な支払いコールバック',
                noPriceId: '価格情報が設定されていません',
            },
        },
    },
};
